// extracted by mini-css-extract-plugin
module.exports = {"censusUploadForm":"UploadCensus_censusUploadForm__3pIwZ","loaderContainer":"UploadCensus_loaderContainer__3-iv6"};